import React, { Component } from 'react';
import { Formik, Form, ErrorMessage } from 'formik';
import { FormikTextField } from 'formik-material-fields';
import * as Yup from 'yup';
import Button from '@material-ui/core/Button';
import InputAdornment from '@material-ui/core/InputAdornment';
import { dataService } from '../Services/data-service';
import { withStyles } from "@material-ui/core/styles";
import * as roles from '../AppData/roles';


class LoginPage extends Component {
    constructor(props) {
        super(props);
        // redirect to home if already logged in
        if (this.props.authReducer.loggedIn) {
            this.props.history.push(process.env.PUBLIC_URL + "/");
        }
    }

    submitLoginForm = ({ username, password }, { setStatus, setSubmitting }) => {
        setStatus();
        setSubmitting(true);
        dataService.authenticate(username, password)
            .then(
                loginResult => {
                    console.log(loginResult);
                    if (loginResult.Succeeded) 
                    {
                        if (loginResult.Results[0].Roles && loginResult.Results[0].Roles.includes(roles.USER_ROLE)) {
                            this.props.actions.login(loginResult.Results[0].UserID, loginResult.Results[0].UserName, loginResult.Results[0].LanguageCode, loginResult.Results[0].Roles);
                            this.props.history.push(process.env.PUBLIC_URL + "/");
                        } else {
                            this.props.actions.logout();
                            setStatus("You're not authorized to use the application.");
                            setSubmitting(false);
                        }
                    } else {
                        // Show feedback api
                        this.props.actions.logout();
                        setStatus(loginResult.Messages[0]);
                        setSubmitting(false);
                    }
                },
                error => {
                    setStatus(error.message);
                    setSubmitting(false);
                }
            );
    };

    render() {
        const { classes } = this.props;

        return (
            <div className={classes.background}>
                <div className="spacer200"></div>
                <Formik
                    initialValues={{ username: '', password: '' }}
                    validationSchema={Yup.object().shape({
                        username: Yup.string().required('Username is required'),
                        password: Yup.string().required('Password is required')
                    })}
                    onSubmit={this.submitLoginForm}>
                    {({ errors, status, touched, isSubmitting }) => (
                        <div className={classes.loginContainer}>
                            <div className={classes.logoContainer}>
                                <img className={classes.logo} src={process.env.PUBLIC_URL + "/img/mydibel-logo.svg"} />
                            </div>
                            <h1 className={classes.formTitle}>Login</h1>
                            {status &&
                                <div className={classes.validationFeedback}>{status}</div>
                            }
                            <Form>
                                <div className="form-group">
                                    <FormikTextField
                                        name="username"
                                        type="text"
                                        fullWidth
                                        className={(errors.username && touched.username ? ' is-invalid' : '')}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start" >
                                                    <img src={process.env.PUBLIC_URL + "/img/userIcon.svg"} />
                                                </InputAdornment>
                                            ),
                                        }} />
                                </div>
                                <div className="spacer10"></div>
                                <div className="form-group">
                                    <FormikTextField
                                        name="password"
                                        type="password"
                                        fullWidth
                                        className={(errors.password && touched.password ? ' is-invalid' : '')}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <img src={process.env.PUBLIC_URL + "/img/passwordIcon.svg"} />
                                                </InputAdornment>
                                            ),
                                        }} />
                                </div>
                                <div className="spacer30"></div>
                                <div className="form-group">
                                    <Button fullWidth variant="contained" color="primary" type="submit" className="btn btn-primary" disabled={isSubmitting}>
                                        {isSubmitting &&
                                            <div className={classes.CenteredContent}>
                                                <img alt='loading' src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                                            </div>
                                        }<div className="whiteText">Login</div>
                                    </Button>
                                </div>
                            </Form>
                        </div>
                    )}
                </Formik>
            </div>
        )
    }
}

const styles = {
    background: {
        backgroundColor: "#eee",
        background: 'url('+ process.env.PUBLIC_URL + '/img/loginBackground.png)', 
        height: "100vh"
    },
    formTitle: {
        color: "#1583C3",
        fontSize: "35px",
        fontWeight: 100,
        marginLeft: "5%",
        marginTop: "20px"
    },
    loginContainer: {
        width: "400px",
        margin: 'auto',
        backgroundColor: '#FFFFFF',
        paddingBottom: "20px"
    },
    logoContainer: {
        textAlign: "center"
    },
    logo: {
        marginTop: "-70px",
    },
    validationFeedback:{
        marginLeft: "5%",
        marginBottom: "10px",
        color: "red",
        fontWeight: 600,
        width: "90%"
    },
    CenteredContent: {
        justifyContent: 'center',
        alignContent: 'center'
    }
};

export default withStyles(styles)(LoginPage);
